var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 749,
    height: 666,
    viewBox: "0 0 749 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4559_833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 549,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.621 549.329H233.021V607.604H532.621V549.329Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4559_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.688 602.934C453.857 602.934 511.55 545.222 511.55 474.03C511.55 402.838 453.857 345.125 382.688 345.125C311.52 345.125 253.827 402.838 253.827 474.03C253.827 545.222 311.52 602.934 382.688 602.934Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.021 547.248H532.622",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.649 274.09L293.187 469.665C293.084 483.522 304.233 494.843 318.09 494.951L427.473 495.804C441.33 495.913 452.647 484.767 452.75 470.911L454.211 275.335C454.315 261.478 443.166 250.158 429.309 250.05L319.926 249.196C306.069 249.088 294.752 260.233 294.649 274.09Z",
    fill: "#E4E2E2",
    stroke: "#343239",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M294.649 274.09L293.187 469.665C293.084 483.522 304.233 494.843 318.09 494.951L427.473 495.804C441.33 495.913 452.647 484.767 452.75 470.911L454.211 275.335C454.315 261.478 443.166 250.158 429.309 250.05L319.926 249.196C306.069 249.088 294.752 260.233 294.649 274.09Z",
    fill: "#343239",
    stroke: "#343239",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.881 465.75L402.513 381.249",
    stroke: "#343239",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.002 465.889L420.422 409.555",
    stroke: "#343239",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M349.959 469.071L374.398 469.262C379.312 469.3 383.326 465.347 383.363 460.433L383.62 426.053C383.656 421.138 379.702 417.123 374.788 417.085L350.348 416.894C345.434 416.856 341.42 420.809 341.384 425.723L341.127 460.103C341.09 465.018 345.044 469.033 349.959 469.071Z",
    fill: "#E8E8E8",
    stroke: "#343239",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M342.436 450.377L382.2 450.689",
    stroke: "#343239",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M379.828 435.758L354.974 435.564L355.086 420.652",
    stroke: "#343239",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M379.828 435.758L369.887 435.68L369.997 420.769",
    stroke: "#343239",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M369.667 465.502L369.779 450.59",
    stroke: "#343239",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M354.751 465.388L354.862 450.476",
    stroke: "#343239",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M320.874 345.636L320.882 341.858C321.548 341.833 321.875 341.35 321.877 340.305C321.88 339.128 321.476 338.748 320.941 338.747C320.105 338.745 320.025 339.66 319.84 340.836C319.575 342.574 319.139 345.436 316.11 345.43C313.565 345.425 311.781 343.408 311.788 340.271C311.794 337.133 313.612 335.189 315.871 335.129L315.863 338.854C315.275 338.958 314.948 339.467 314.946 340.225C314.944 341.166 315.427 341.559 315.936 341.56C316.706 341.562 316.799 340.647 316.984 339.471C317.249 337.654 317.738 334.884 320.714 334.89C323.311 334.896 325.043 337.043 325.036 340.285C325.029 343.527 323.289 345.615 320.874 345.662L320.874 345.636Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M319.751 333.372L307.664 333.347L307.672 329.517L312.136 329.526L312.149 323.552L315.595 323.559L315.582 329.533L319.759 329.542C321.09 329.545 321.496 328.931 321.498 328.094C321.5 327.258 321.096 326.643 319.765 326.64L319.387 326.639L319.394 322.809L319.773 322.81C323.362 322.817 325.068 324.964 325.061 328.102C325.055 331.239 323.341 333.379 319.751 333.372V333.372Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M317.583 321.472C313.654 321.463 311.831 319.159 311.838 315.786C311.845 312.414 313.664 310.143 317.633 310.138L317.711 310.138L317.703 313.968L317.598 313.968C315.915 313.965 315.404 314.735 315.402 315.807C315.4 316.879 315.907 317.651 317.591 317.654L324.757 317.669L324.749 321.499L317.583 321.485L317.583 321.472Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M325.988 309.005L325.996 305.175C326.833 304.797 327.173 304.131 327.176 302.903C327.179 301.216 326.385 300.47 324.479 300.466L323.226 300.463C324.321 301.184 324.906 302.284 324.903 303.604C324.898 306.258 323.104 309.091 318.496 309.081L312.178 309.068L312.186 305.238L318.504 305.251C320.488 305.255 321.338 304.289 321.341 302.851C321.344 301.413 320.459 300.444 318.514 300.44L312.196 300.427L312.204 296.597L324.356 296.622C328.742 296.631 330.498 299.445 330.491 302.883C330.485 305.864 329.109 308.345 325.988 308.979L325.988 309.005Z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M312.207 295.12L312.216 291.015L321.163 288.249L312.227 285.446L312.236 281.433L324.822 285.982L324.813 290.623L312.207 295.12V295.12Z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M318.527 281.446C314.703 281.438 311.902 278.622 311.911 274.648C311.919 270.674 314.731 267.935 318.555 267.942L319.626 267.945L319.606 277.461C321.081 277.164 321.749 276.041 321.752 274.655C321.755 273.557 321.521 272.746 320.844 272.248L320.852 268.287C323.448 269.103 325.179 271.512 325.172 274.649C325.164 278.636 322.352 281.428 318.527 281.42L318.527 281.446ZM317.203 271.874C315.897 272.303 315.333 273.322 315.33 274.655C315.328 275.988 315.913 277.009 317.191 277.391L317.203 271.874Z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M327.862 368.318L327.877 361.181C327.884 357.873 325.214 355.175 321.899 355.168L310.256 355.144C311.659 358.036 313.718 359.726 318.44 361.331C323.683 363.12 326.211 365.373 327.876 368.318L327.862 368.318Z",
    fill: "#1A1A1A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M308.855 356.984L308.832 368.2C308.825 371.507 311.495 374.206 314.81 374.213L323.334 374.23C322.546 370.059 320.436 368.093 316.773 365.72C311.845 362.546 310.465 361.171 308.855 356.984V356.984Z",
    fill: "#1A1A1A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 69,
    width: 212,
    height: 315,
    rx: 19,
    fill: "#F6F3F3",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 106,
    width: 181,
    height: 112,
    rx: 9,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 231.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 348.5,
    y: 231.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 414.5,
    y: 231.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 276.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 348.5,
    y: 276.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 414.5,
    y: 276.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 321.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 348.5,
    y: 321.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 414.5,
    y: 321.5,
    width: 50,
    height: 36,
    rx: 9.5,
    fill: "#E4E2E2",
    stroke: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M403.733 153.806C403.579 153.291 403.222 152.86 402.75 152.605C402.278 152.351 401.723 152.294 401.206 152.448C400.69 152.601 400.256 152.952 399.994 153.424C399.739 153.896 399.682 154.451 399.829 154.968C401.621 160.966 401.232 167.404 398.725 173.142C396.225 178.879 391.772 183.547 386.159 186.316C380.546 189.086 374.135 189.779 368.056 188.273C361.983 186.767 356.638 183.159 352.964 178.088C349.296 173.018 347.542 166.811 348.007 160.569C348.473 154.327 351.133 148.452 355.522 143.985C359.904 139.517 365.728 136.746 371.96 136.163C378.192 135.579 384.43 137.22 389.572 140.795C390.012 141.104 390.56 141.225 391.096 141.13C391.626 141.035 392.098 140.733 392.41 140.289C392.716 139.845 392.838 139.297 392.742 138.765C392.646 138.233 392.346 137.761 391.9 137.451C385.987 133.343 378.811 131.459 371.641 132.135C364.471 132.809 357.773 136 352.728 141.141C347.682 146.281 344.62 153.041 344.085 160.222C343.549 167.404 345.571 174.544 349.787 180.378C354.01 186.213 360.159 190.366 367.15 192.101C374.141 193.836 381.515 193.043 387.977 189.86C394.439 186.679 399.561 181.313 402.45 174.714C405.334 168.115 405.786 160.709 403.733 153.806Z",
    fill: "#343239"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M361.48 161.142C361.089 160.766 360.575 160.558 360.035 160.563C359.496 160.567 358.982 160.785 358.604 161.167C358.225 161.551 358.006 162.069 358 162.61C358 163.152 358.205 163.674 358.578 164.064L368.832 174.395C369.218 174.782 369.738 175 370.283 175C370.829 175 371.349 174.782 371.735 174.395L399.422 146.502C399.801 146.112 400.006 145.59 400 145.048C399.993 144.506 399.782 143.988 399.403 143.605C399.017 143.222 398.504 143.005 397.964 143C397.431 142.996 396.911 143.204 396.526 143.58L370.283 170.013L361.48 161.142Z",
    fill: "#343239"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness2);
export default __webpack_public_path__ + "static/media/business-2.7c7c039cf451fbb8bea8627ddd08b443.svg";
export { ForwardRef as ReactComponent };